module.exports = __webpack_public_path__ + "img/Globe_Life-220.bc2408ba.png";